var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Rating"}},_vm._l((5),function(n){return _c('span',{key:n,staticClass:"pointer",on:{"click":function($event){return _vm.setRating(n)}}},[_c('Star',{attrs:{"on":_vm.score>=n}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }